// Mock data for Romano Heating and Cooling Website

export const companyInfo = {
  name: "Romano Heating and Cooling",
  tagline: "Your Trusted HVAC Partner Since 2005",
  phone: "916-274-9021",
  email: "info@romanoheatingandcooling.com",
  address: "1316 Church Street, Roseville, California 95678",
  logo: "https://img1.wsimg.com/isteam/ip/724d934d-f1fe-4cd2-9b70-11db08042ddd/RomanoBrand%201-6c1d8e9.jpeg",
  socialLinks: {
    facebook: "https://www.facebook.com/romano.galanti.3",
    instagram: "https://www.instagram.com/romanoheatingcooling"
  },
  serviceAreas: ["Roseville", "Rocklin", "Folsom", "El Dorado", "South Placer County", "Sacramento County", "San Joaquin County"],
  businessHours: [
    { day: "Monday", hours: "6:00 AM - 10:00 PM" },
    { day: "Tuesday", hours: "6:00 AM - 10:00 PM" },
    { day: "Wednesday", hours: "6:00 AM - 10:00 PM" },
    { day: "Thursday", hours: "6:00 AM - 10:00 PM" },
    { day: "Friday", hours: "6:00 AM - 10:00 PM" },
    { day: "Saturday", hours: "6:00 AM - 10:00 PM" },
    { day: "Sunday", hours: "6:00 AM - 10:00 PM" }
  ]
};

export const services = [
  {
    id: 1,
    title: "AC Tune-Up",
    description: "Keep your air conditioning system running all summer long with our comprehensive AC tune-up services. At Romano Heating and Cooling, our certified technicians perform thorough inspections, cleaning, and lubrication of all components to maximize performance and extend the lifespan of your AC unit.",
    icon: "Snowflake"
  },
  {
    id: 2,
    title: "Heating Maintenance",
    description: "Ensure your heating system operates at peak efficiency with our comprehensive heating maintenance services at Romano Heating and Cooling. Our expert technicians provide thorough inspections, cleaning, and tune-ups to keep your heating system running smoothly and effectively.",
    icon: "Flame"
  },
  {
    id: 3,
    title: "Thermostat Installation",
    description: "Save money on energy bills with our affordable thermostat installation services. We help you choose the right smart thermostat for your home.",
    icon: "Thermometer"
  },
  {
    id: 4,
    title: "Emergency Services",
    description: "24/7 emergency HVAC services when you need help most. Our team handles all emergencies including AC breakdowns and heating system failures.",
    icon: "AlertTriangle"
  },
  {
    id: 5,
    title: "Commercial HVAC",
    description: "Affordable commercial HVAC maintenance to save on energy bills and prevent costly breakdowns. Expertise in all commercial systems.",
    icon: "Building2"
  },
  {
    id: 6,
    title: "Air Duct Cleaning",
    description: "Improve indoor air quality with our professional air duct cleaning. State-of-the-art equipment removes dirt, dust, and debris effectively.",
    icon: "Wind"
  },
  {
    id: 7,
    title: "Restaurant Equipment Repair",
    description: "Fast, reliable repair and maintenance for all your commercial kitchen essentials, from ovens and ranges to refrigerator units. We get your kitchen back to peak efficiency.",
    icon: "UtensilsCrossed"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    location: "Roseville, CA",
    rating: 5,
    text: "Romano Heating and Cooling saved us during a heat wave! Their emergency service was fast, professional, and reasonably priced. Highly recommend!",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop"
  },
  {
    id: 2,
    name: "Michael Chen",
    location: "Rocklin, CA",
    rating: 5,
    text: "We've been using Romano for over 5 years. Their maintenance plans keep our HVAC running perfectly. The team is always friendly and on time.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    location: "Folsom, CA",
    rating: 5,
    text: "From estimate to installation, the entire process was seamless. They installed our new furnace in one day and it's been working flawlessly!",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop"
  }
];

export const galleryImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_romano-modern/artifacts/njjfxv4s_New%20Lennox%20package.jpg",
    alt: "New Lennox package unit installation on residential roof",
    category: "Installation"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_romano-modern/artifacts/ojnw8x9v_New%20const.jpg",
    alt: "New construction HVAC ductwork installation",
    category: "Installation"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_romano-modern/artifacts/zt9f73oy_Crain%20lift%20%281%29%20%281%29.jpg",
    alt: "Crane lifting HVAC unit to residential roof",
    category: "Installation"
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_romano-modern/artifacts/kimba918_Sutter%20st%20new%20coil%20%281%29.jpg",
    alt: "New condenser coil installation on commercial rooftop - Sutter Street",
    category: "Commercial"
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_romano-modern/artifacts/9el689ss_Really%20dirty%20ac.jpg",
    alt: "Extremely dirty AC coils showing need for professional cleaning",
    category: "Maintenance"
  },
  {
    id: 6,
    src: "https://customer-assets.emergentagent.com/job_romano-modern/artifacts/p00531yd_No%20compressor.jpg",
    alt: "AC unit interior during repair service",
    category: "Repair"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "20+ Years Experience",
    description: "Serving the community with quality HVAC services since 2005"
  },
  {
    id: 2,
    title: "100% Satisfaction Guarantee",
    description: "If you're not satisfied, we'll make it right"
  },
  {
    id: 3,
    title: "Licensed & Insured",
    description: "Fully licensed technicians you can trust"
  },
  {
    id: 4,
    title: "24/7 Emergency Service",
    description: "We're here when you need us most"
  }
];
